import { combineReducers } from 'redux-immutable'
import subcontractCostGetReducer from './subcontract-cost-get-reducer'
import subcontractCostCreateReducer from './subcontract-cost-create-reducer'
import subcontractCostEditReducer from './subcontract-cost-edit-reducer'
import subcontractCostExportReducer from './subcontract-cost-export-reducer'

export default combineReducers({
  subcontractCostGet: subcontractCostGetReducer,
  subcontractCostCreate: subcontractCostCreateReducer,
  subcontractCostEdit: subcontractCostEditReducer,
  subcontractCostExport: subcontractCostExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/subcontract-cost/index.js